export interface InstitutionProgram {
  schoolProgramId?: number; // PK
  opeid: string;
  programName?: string;
  schoolId?: number;
  schoolProgramEdLevelId?: number;
  isOnline?: boolean;
  qualityMetric?: number;
  alignment?: number;
  avarageCost?: boolean;
  medianDebts?: number[];
  graduationRate?: number[];
  cipCode?: string;
  /** ENRICH.6: the official (CIP) title, shown as "Official program: ..." under programName. */
  officialTitle?: string | null;
}

export const schoolProgramEdLevels: {
  edLevelId: number;
  edLevelName: string;
}[] = [
  { edLevelId: 3, edLevelName: `Certificate` },
  { edLevelId: 5, edLevelName: `Associate's Degree` },
  { edLevelId: 6, edLevelName: `Bachelor's Degree` },
  { edLevelId: 8, edLevelName: `Master's Degree` }
];

export const institutionProgramOccupationAlignments: {
  cipCodeCutoff: number;
  alignmentName: string;
}[] = [
  { cipCodeCutoff: 7, alignmentName: 'Recommended Programs' },
  { cipCodeCutoff: 5, alignmentName: 'Closely related Programs' },
  { cipCodeCutoff: 3, alignmentName: 'Programs in a related field' },
  { cipCodeCutoff: 1, alignmentName: 'Somewhat related Programs' },
  { cipCodeCutoff: 0, alignmentName: 'Any Programs' }
];

export const institutionMedianDebts: {
  value: number;
  name: string;
}[] = [
  { value: 1, name: '$0 - $5,000' },
  { value: 2, name: '$5,001 - $10,000' },
  { value: 3, name: '$10,001 - $20,000' },
  { value: 4, name: '$30,001 and above' }
];

export const institutionGraduationRates: {
  value: number;
  name: string;
}[] = [
  { value: 1, name: 'Less than 40%' },
  { value: 2, name: '40% - 60%' },
  { value: 3, name: '61% - 80%' },
  { value: 4, name: '81% and above' }
];

export const institutionMedianEarnings: {
  value: number;
  name: string;
}[] = [
  { value: 1, name: 'Less than $30,000' },
  { value: 2, name: '30,000 - $50,000' },
  { value: 3, name: '$50,001 - $75,000' },
  { value: 4, name: '$75,001 and above' }
];
